export default __webpack_public_path__ + "static/media/POPPINS-BOLD.9f0cd50b.TTF";